module.exports = __webpack_public_path__ + "static/media/bj.8cc998a9.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/components/RollingData/images/bj.jpg
// module id = 55
// module chunks = 0